// tslint:disable:no-null-keyword
import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import * as moment from 'moment';
import { isInArray } from '../../core/util/is-in-array';

export class CustomValidators {

    static emptyEmail(control: AbstractControl): ValidationErrors | null {
        if (control.value === '') {
            return null;
        }

        return {
            'not empty': true
        };
    }

    static validOrEmptyEmail(control: AbstractControl): CustomValidators | null {

        if (!control.value) {
            // tslint:disable-next-line:no-null-keyword
            return null;
        }

        return Validators.email(control);
    }

    static dateFormat(format?: string): (c: AbstractControl) => ValidationErrors | null {
        return (c: AbstractControl): ValidationErrors | null => {

            const value = c.value;
            const m = moment(value, format);

            if (!m.isValid()) {
                return {
                    invalidDate: {}
                };
            }

            return null;
        };
    }

    static fileName(control: AbstractControl): ValidationErrors | null {

        const rg1 = /[a-zA-Z0-9\s.\-_]*/g; // valid characters
        const rg2 = /^\./; // cannot start with dot (.)

        const name = control.value;

        if (!name || name.replace(rg1, '').length > 0 || rg2.test(name) || name.length > 255) {
            return {
                invalidFileName: {}
            };
        }

        return null;
    }

    static fileTypeImage(control: AbstractControl): ValidationErrors | null {
        let mime: string;
        let value = control.value;

        // if the value came from FileControlComponent
        if (value && value.base64 !== undefined) {
            value = value.base64;
        }

        if (!value) {
            // tslint:disable-next-line:no-null-keyword
            return null;
        }

        try {
            mime = value.substring(0, value.indexOf(';')).split(':')[1];
        } catch (e) {
            return {
                'cannotDetermineMime': false
            };
        }

        if (!mime.match(/image\//)) {
            return {
                'invalidMime': false
            };
        }

        // tslint:disable-next-line:no-null-keyword
        return null;
    }

    static currency(control: AbstractControl): ValidationErrors | null {
        const value = control.value || '';

        if (isInArray(value, ['0', ''])) {
            // tslint:disable-next-line:no-null-keyword
            return null;
        }

        // @todo add a regex for european format

        const regex = /^([0-9]{1,3},([0-9]{3},)*[0-9]{3}|[0-9]+)(.[0-9][0-9])?$/;

        const errors = {
            // tslint:disable-next-line:no-null-keyword
            'invalid': !regex.test(value) ? Error('allowed formats 1000.00 or 1000 or 1,000 or 1,000.00') : null
        };

        if (Object.keys(errors).map(key => errors[key]).find(error => !!error)) {
            return errors;
        }

        // tslint:disable-next-line:no-null-keyword
        return null;
    }

    static blackList(blackList: Array<string> = [], errorKey = 'blackList'): (control: AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {

            const value = control.value;

            if (!value || blackList.length === 0) {
                return null;
            }

            if (!isInArray(value, blackList)) {
                return null;
            }

            return {
                [errorKey]: {
                    value
                }
            };
        };
    }

    static integer(control: AbstractControl): ValidationErrors | null {

        const value = (control.value || '').toString();

        if (!value) {
            return null;
        }

        const integer = parseInt(value, 10);

        if (!Number.isInteger(integer) || isNaN(value)) {
            return {
                'invalidInteger': false
            };
        }
    }

    static float(control: AbstractControl): ValidationErrors | null {

        const value = (control.value || '').toString();

        if (!value) {
            return null;
        }

        if (isNaN(value)) {
            return {
                'invalidFloat': false
            };
        }
    }

    static range(
        min: number,
        max: number
    ): (control: AbstractControl) => ValidationErrors | null {
        return (control: AbstractControl): ValidationErrors | null => {

            const value = (control.value || '').toString();

            if (!value) {
                return null;
            }

            const float = parseFloat(value);

            if (
                isNaN(value) ||
                float > max ||
                float < min
            ) {
                return {
                    'notInRange': {min, max}
                };
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/vas/validators/custom-validators.ts